import ConnectedAccountsFull from './components/ConnectedAccountsFull';
import * as React from 'react';
import { connectedAccountsStore } from './store/store';
import { onDiscardConnectedAccountOption } from './orchestrators/onDiscardConnectedAccountOption';
import { onSaveConnectedAccountOption } from './orchestrators/onSaveConnectedAccountOption';
import { isControlFeatureEnabled } from 'owa-controls-feature-flags';
var ConnectedAccountsOption = {
    key: 'connected',
    titleStringKey: 'optionTitle_connected',
    searchTermsStringKey: 'optionTitle_connected',
    fullOptionFormSettings: {
        render: function () { return React.createElement(ConnectedAccountsFull, null); },
        isDirty: function () {
            return connectedAccountsStore().isConnectedAccountsDirty ||
                connectedAccountsStore().isDefaultFromDirty;
        },
        onSave: onSaveConnectedAccountOption,
        onDiscard: onDiscardConnectedAccountOption,
    },
    isHidden: function () { return !isControlFeatureEnabled('auth-connectedAccounts'); },
};
export default ConnectedAccountsOption;
//# sourceMappingURL=ConnectedAccountsOption.js.map